import React from "react";
import { 
  XCircle, 
  BookOpen, 
  Cpu, 
  CheckCircle2, 
  Clock, 
  Briefcase,
  HelpCircle,
  AlertTriangle,
  Users
} from "lucide-react";
import "./benefits.css";

const Benefits = () => {
  const painPoints = [
    {
      icon: <XCircle className="benefit-icon-error" size={24} />,
      text: "Professores sem didática ou paciência para ensinar do zero."
    },
    {
      icon: <AlertTriangle className="benefit-icon-warning" size={24} />,
      text: "Foco em decorar fórmulas superficialmente apenas para passar em provas."
    },
    {
      icon: <Clock className="benefit-icon-warning" size={24} />,
      text: "Aulas com hora marcada e engessadas, complicadas para quem tem rotina corrida."
    }
  ];

  const solutions = [
    {
      icon: <BookOpen size={28} />,
      title: "Conceitos Claros e Sequenciais",
      description: "Aprenda circuitos em CC, CA, fasores e impedância sem nós na cabeça, do básico ao avançado."
    },
    {
      icon: <Cpu size={28} />,
      title: "Aplicações no Mundo Real",
      description: "Entenda a teoria conectada com a prática e veja como a engenharia elétrica funciona de verdade."
    },
    {
      icon: <CheckCircle2 size={28} />,
      title: "Exercícios de Fixação",
      description: "Treine com listas focadas para dominar a matéria e detonar nas provas da faculdade."
    },
    {
      icon: <Clock size={28} />,
      title: "Economize Tempo (e Semestres)",
      description: "Evite reprovações que atrasam sua formatura e custam caro para o seu bolso e seu psicológico."
    },
    {
      icon: <Briefcase size={28} />,
      title: "Base Sólida para o Mercado",
      description: "Chegue nas entrevistas de estágio e emprego dominando a base da sua formação como engenheiro."
    },
    {
      icon: <Users size={28} />,
      title: "Comunidade e Suporte",
      description: "Interaja com outros alunos de engenharia, aprenda em conjunto e tire suas dúvidas diretamente com o professor sempre que precisar."
    }
  ];

  return (
    <section className="de-benefits-section">
      <div className="de-benefits-container">
        
        {/* CONTEXTO / DOR */}
        <div className="de-benefits-intro">
          <h2>Dificuldade com Circuitos Elétricos?</h2>
          <p className="de-subtitle">
            Corrente contínua, alternada, fasores, impedância... A matéria acumula e o desespero bate. 
            Nossos alunos também passavam por isso. E o motivo é claro:
          </p>
        </div>

        {/* O PROBLEMA DAS FACULDADES */}
        <div className="de-pain-grid">
          <div className="de-pain-card-title">
            <h3>O cenário comum na maioria das faculdades:</h3>
          </div>
          <div className="de-pain-cards">
            {painPoints.map((point, index) => (
              <div key={index} className="de-pain-card">
                {point.icon}
                <p>{point.text}</p>
              </div>
            ))}
          </div>
        </div>

        {/* A SOLUÇÃO: DOMÍNIO ELÉTRICO */}
        <div className="de-solution-wrapper">
          <div className="de-solution-header">
            <h2>Por que estudar no <span>Domínio Elétrico</span>?</h2>
            <p>O método ideal para você dominar a matéria e garantir sua aprovação.</p>
          </div>

          <div className="de-solution-grid">
            {solutions.map((sol, index) => (
              <div key={index} className="de-sol-card">
                <div className="de-sol-icon-box">
                  {sol.icon}
                </div>
                <div className="de-sol-content">
                  <h3>{sol.title}</h3>
                  <p>{sol.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default Benefits;